import { useState } from 'react';

const faqs = [
  {
    question: 'What types of private health insurance plans do you offer in Houston?',
    answer:
      'We offer individual health plans, family coverage, company group plans, Medicare supplements, short-term health insurance, and specialized coverage options including dental, vision, and critical illness. As an independent broker, we compare plans from 50+ carriers to find the best private health insurance for your needs in Houston.',
  },
  {
    question: 'How does your 24/7 availability work for health insurance consultations?',
    answer:
      "Data Health Insurance Consultants is open 24 hours a day, 7 days a week. You can call us at (713) 804-9039 anytime, submit a quote request through our website, or visit our Houston office at 1500 North Blvd Ste 5000 1006, Houston TX 77006. We understand that health insurance questions don't follow business hours.",
  },
  {
    question: 'Do you charge consultation fees for health insurance advice?',
    answer:
      'No, our consultations are completely free. As an independent insurance broker in Houston, we are compensated by insurance carriers, not by our clients. You receive expert advice and market comparisons at absolutely no cost to you.',
  },
  {
    question: 'What areas of Houston do you serve for private health insurance?',
    answer:
      'We serve all of Houston and the greater Houston metropolitan area, including The Heights, Montrose, Midtown, River Oaks, Memorial, Katy, Sugar Land, The Woodlands, Pearland, and surrounding communities in Harris County and beyond.',
  },
  {
    question: 'How quickly can I get private health insurance coverage in Houston?',
    answer:
      'Depending on the plan type, coverage can begin as soon as the next day for some short-term plans, or on the first of the following month for most major medical plans. Our Houston team works quickly to compare options and get you covered as fast as possible.',
  },
  {
    question: 'What is the difference between individual and group health insurance plans?',
    answer:
      'Individual health insurance covers a single person or family and is purchased directly. Group health insurance is offered by employers to their employees, often at lower rates due to risk pooling. Data Health Insurance Consultants in Houston helps with both types, comparing private health insurance options across multiple carriers to find the best value.',
  },
];

export default function FAQ() {
  // Start with no FAQ opened (null). Using null avoids assuming an index exists.
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // Toggle handler with safety checks
  const toggleFAQ = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <section id="faq" className="py-24 bg-navy-50/40">
      <div className="max-w-[900px] mx-auto px-8 lg:px-12">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-2 text-brand-600 text-sm font-semibold tracking-wider uppercase mb-3">
            <span className="w-8 h-[2px] bg-brand-500"></span>
            FAQ
            <span className="w-8 h-[2px] bg-brand-500"></span>
          </span>
          <h4 className="text-4xl font-display font-bold text-navy-900 mb-3">
            <a href="#faq">Frequently Asked Questions</a>
          </h4>
          <p className="text-navy-500 text-base">
            Common questions about private health insurance in Houston answered by our expert consultants.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl border transition-all duration-300 ${
                openIndex === index ? 'border-brand-200 shadow-md' : 'border-navy-100'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
                aria-expanded={openIndex === index}
                aria-controls={`faq-answer-${index}`}
              >
                <span className="text-navy-900 font-semibold text-base pr-4">{faq.question}</span>
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    openIndex === index ? 'bg-brand-500 rotate-180' : 'bg-navy-100'
                  }`}
                >
                  <i
                    className={`ri-arrow-down-s-line text-lg ${
                      openIndex === index ? 'text-white' : 'text-navy-500'
                    }`}
                  ></i>
                </div>
              </button>
              <div
                id={`faq-answer-${index}`}
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'
                }`}
              >
                <p className="px-6 text-navy-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
